/* Medium Charlotte – Mondphase für den Kopf der Seite (29.09.2026). Nutzt die Mond-Ereignisse aus window.MC_MOND_EV ([unix, typ]). */
(function () {
  'use strict';
  var ev = window.MC_MOND_EV;
  if (!ev || !ev.length) return;
  var NAMEN = ['Neumond', 'Zunehmende Sichel', 'Erstes Viertel', 'Zunehmender Mond', 'Vollmond', 'Abnehmender Mond', 'Letztes Viertel', 'Abnehmende Sichel'];
  var WINKEL = { N: 0, E: 90, V: 180, L: 270 };
  var jetzt = Date.now(), vorher = null, nachher = null;
  for (var i = 0; i < ev.length; i++) {
    if (ev[i][0] * 1000 <= jetzt) vorher = ev[i]; else { nachher = ev[i]; break; }
  }
  if (!vorher || !nachher) return;
  var a0 = WINKEL[vorher[1]], a1 = WINKEL[nachher[1]];
  if (a1 <= a0) a1 += 360;
  var el = (a0 + (a1 - a0) * (jetzt - vorher[0] * 1000) / ((nachher[0] - vorher[0]) * 1000)) % 360;
  var tag;
  try { tag = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit' }); } catch (e) { return; }
  function schluessel(ms) { return tag.format(new Date(ms)); }
  var heute = schluessel(jetzt), idx = null;
  for (var j = 0; j < ev.length; j++) if (schluessel(ev[j][0] * 1000) === heute) idx = { N: 0, E: 2, V: 4, L: 6 }[ev[j][1]];
  if (idx === null) idx = { N: 1, E: 3, V: 5, L: 7 }[vorher[1]];
  var r = 54, R = Math.PI / 180, pfad = '';
  if (el >= 1.5 && el <= 358.5) {
    var rx = (Math.abs(Math.cos(el * R)) * r).toFixed(2);
    if (el < 180) pfad = 'M60,6 A54,54 0 0 1 60,114 A' + rx + ',54 0 0 ' + (el < 90 ? 0 : 1) + ' 60,6 Z';
    else pfad = 'M60,6 A54,54 0 0 0 60,114 A' + rx + ',54 0 0 ' + (el > 270 ? 1 : 0) + ' 60,6 Z';
  }
  var alle = document.querySelectorAll('[data-mc-mini-licht]');
  for (var k = 0; k < alle.length; k++) alle[k].setAttribute('d', pfad);
  var namen = document.querySelectorAll('[data-mc-mini-name]');
  for (var n = 0; n < namen.length; n++) namen[n].textContent = NAMEN[idx];
})();
